import React, { useState, useEffect } from 'react';

import UserContext from './user.context';

const GlobalContext = props => {
  const userInitState = {
    username: null,
    name: null,
    tokens: {},
    userConfirmed: null,
    authenticated: null,
    isVerifyOtp: false,
    timestamp: null,
    insights: null,
    dropdowns: {
      adaccount: null,
      businessManager: null,
    },
    trackingIds: [],
  };

  const localStorageUser = localStorage.getItem('user');
  let initialUser = localStorageUser ? JSON.parse(localStorageUser) : userInitState;
  const [user, setUser] = useState(initialUser);

  useEffect(() => {
    if (user === null) return setUser(userInitState);
    localStorage.setItem('user', JSON.stringify(user));
    ////console.log('User Context Updated');
  }, [user]);

  return <UserContext.Provider value={{ user, setUser }}>{props.children}</UserContext.Provider>;
};

export default GlobalContext;
